import * as Yup from 'yup';
import { common_passwords } from '../../../utilities/commonPasswords';

const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[[\]@_!#$%^&*()<>?/\|}{~:])[a-zA-Z\d\w\W]{8,20}$/g;
let userNameValidator = Yup.string()
  .email('Invalid email address')
  .required('Email is required');
let newPasswordValidator = Yup.string()
  .min(8, 'Must be Minimum 8 characters')
  .required('Password is required')
  .matches(passwordRegEx, 'Not a valid Password')
  .notOneOf(
    [Yup.ref('userName'), ...common_passwords],
    'Password is not strong, Please adhere to the password policy'
  );
let confirmPasswordValidator = Yup.string()
  .min(8, 'Must be Minimum 8 characters')
  .oneOf([Yup.ref('newPassword')], 'Password Should be same')
  .required('Confirm password is Required');

export const forgotPasswordFormSchema = Yup.object().shape({
  userName: userNameValidator,
});

export const loginFormSchema = Yup.object().shape({
  userName: userNameValidator,
  password: Yup.string()
    .min(8, 'Must be Minimum 8 characters')
    .required('Password is required'),
});

export const passwordResetFormSchema = Yup.object().shape({
  userName: userNameValidator,
  newPassword: newPasswordValidator,
  confirmPassword: confirmPasswordValidator,

  oneTimeCode: Yup.string()
    .max(6, 'Access code should be 6 digit')
    .required('One time code is required'),
});
export const signUpFormSchema = Yup.object().shape({
  userName: userNameValidator,
  newPassword: newPasswordValidator,
  confirmPassword: confirmPasswordValidator,
});

export const modalLoginFormSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Must be Minimum 8 characters')
    .required('Password is required'),
});
